import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { useTranslation } from '../../../shared/i18n';
import * as S from '../Conecta2ProductPage.styles';

const WhatsAppButton = ({ onClick, message }) => {
  const t = useTranslation();
  
  return (
    <S.WhatsAppButton 
      href={message}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
    >
      <FaWhatsapp style={{ fontSize: '1.5rem' }} />
      {t('conecta2Product.price.reserveButton')}
    </S.WhatsAppButton>
  );
};

export default WhatsAppButton;
